<template>
  <div class="line-chat">
    <div class="input">
      <el-input placeholder="请输入内容" v-model="MsgText" clearable></el-input>
      <el-button type="primary" @click="sendMsg">发送信息</el-button>
    </div>
    <div class="chat-view">
      <div class="msg-template" v-for="(msg,index) in lineMsg" :key="index">
        <p>{{msg.name}}:</p>
        <p>{{msg.msg}}</p>
      </div>
    </div>
    <!-- <el-button :plain="true" v-show="false">成功</el-button> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      ws: "",
      MsgText: "",
      lineMsg: []
    };
  },
  methods: {
    wsConnect() {
      this.ws = new WebSocket("ws://192.168.2.220:8000/ws");
      this.ws.onopen = evt => {
        console.log("聊天室连接已建立");
        let data = {
          type: "join",
          name: sessionStorage.getItem("name")
        };
        this.ws.send(JSON.stringify(data));
      };

      this.ws.onmessage = evt => {
        let outData = JSON.parse(evt.data);
        switch (outData.type) {
          case "join":
            if (sessionStorage.getItem("name") != outData.name) {
              this.$message({
                message: `${outData.name}欢迎加入`,
                type: "success",
                duration: 1000
              });
            }
            break;
          case "close":
            if (sessionStorage.getItem("name") != outData.name) {
              this.$message({
                message: `${outData.name}离开了房间`,
                type: "success",
                duration: 1000
              });
            }
            break;
          default:
            this.lineMsg.push({
              name: outData.name,
              msg: outData.data
            });
            break;
        }
      };
    },
    sendMsg() {
      let data = {
        type: "msg",
        data: this.MsgText,
        name: sessionStorage.getItem("name")
      };
      if (this.MsgText != "") {
        this.ws.send(JSON.stringify(data));
        this.MsgText = "";
      }
    }
  },
  mounted() {
    this.wsConnect();
  }
};
</script>
<style lang='scss' scoped>
.line-chat {
  .chat-view {
    .msg-template {
      p {
        &:nth-child(1) {
          width: 20%;
          text-align: center;
          color: #1989fa;
        }
        &:nth-child(2) {
          width: 75%;
        }
      }
      display: flex;
    }
    height: 85vh;
    overflow-y: scroll;
  }
  .input {
    display: flex;
    position: fixed;
    width: 100%;
    bottom: 0;
  }
  padding-top: 1rem;
  background: #fff;
  min-height: 100vh;
  font-size: 0.3rem;
}
</style>

<style lang="scss">
.el-message {
  width: 100%;
  top: 1rem !important;
  font-size: 0.3rem;
}
</style>